// extracted by mini-css-extract-plugin
module.exports = {"tabsWrap":"tabsWrap--2TOPv","tabs":"tabs--1x6m9","affix":"affix--2LxNM"};